export default __webpack_public_path__ + "static/media/level 1.a95bf9e5.svg";